import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Grid, Card, Divider, CardContent, Chip, IconButton, Box, Button, Tabs, Tab } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DEFAULT_DATE_FORMAT } from "config";
import CustomTable from "components/grid/CustomTable";
import ViewActionTracker from "view/actionTracker/ViewActionTracker";
import DocumentManagement from "components/DocumentManagement";
import CustomTabs from "components/CustomTabs";

const getStatusColor = (data) => {
    if (!data) return "purple";

    const status = (data.status || "").toLowerCase();
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);


    // Case 1: In Progress & overdue
    if (status === "in progress" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }

    // Case 2: In Progress & future due date
    if (status === "in progress" && dueDate && dueDate >= today) {
        return { bg: "orange", text: "white" };
    }

    // Case 3: Completed or Closed
    if (status === "completed" || status === "closed") {
        return { bg: "#E1FFBB", text: "#34A853" };
    }

    // Default
    return "purple";
};

const tabs = ["Risk Detail", "Mitigation Plan", "Documents"]

const ViewRisk = (props) => {
    const { open, handleClose, rowData } = props;

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow,] = useState(null);
    //action item related
    const [selectedAction, setSelectedAction] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);

    const handleViewAction = (action) => {
        setSelectedAction(action);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedAction(null);
    };

    const handleMenuOpen = (event, row) => {
        event.stopPropagation(); // prevent row click if any
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };


    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const columns = (onView) => [
        // {
        //     name: "",
        //     field: "actions",
        //     width: "10px",
        //     sticky: true,
        //     renderer: (row) => (
        //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        //             <IconButton
        //                 size="small"
        //                 onClick={(e) => handleMenuOpen(e, row)}
        //             >
        //                 <MoreVertIcon fontSize="small" />
        //             </IconButton>
        //         </Box>
        //     ),
        // },

        {
            name: "Description",
            field: "description",
            width: "200px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {row?.description}
                </Box>
            ),
        },
        {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Assignee",
            field: "assignee",
            // width: "25%",
            renderer: (row) => (
                <>
                    {row?.assignedTo?.split(',')?.map((val, key) => (
                        <Typography key={key} sx={{ fontSize: "16px", fontWeight: 500, color: "#433F5E" }}>
                            {val}
                        </Typography>
                    ))}
                </>
            ),
        },
        {
            name: "Due Date",
            field: 'dueDate',
            renderer: (row) => (
                <>
                    {row?.revisedDueDate ?
                        <>
                            <Chip
                                label={moment.utc(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                sx={{
                                    textDecoration: "line-through",
                                    color: "#e51c1cff",
                                    backgroundColor: "#f5ccccff",
                                    fontWeight: 500,
                                    height: "20px",
                                    borderRadius: "5px",
                                    padding: "2px 6px",
                                    fontFamily: "Outfit",
                                    fontSize: "12px",
                                    marginRight: "5px",
                                }}
                            />
                            {row?.revisedDueDateHistory?.map((val, ind, arr) => {
                                const isLast = ind === arr.length - 1;

                                return (
                                    <Chip
                                        key={ind}
                                        label={moment(val).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            textDecoration: isLast ? "none" : "line-through",
                                            color: isLast ? "#34A853" : "#e51c1cff",
                                            backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "5px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                );
                            })}
                        </>
                        :
                        <>
                            {moment(row?.dueDate).isValid() ?
                                <Chip
                                    label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                    sx={{
                                        // textDecoration: "line-through",
                                        color: getStatusColor(row).text,
                                        backgroundColor: getStatusColor(row).bg,
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "5px",
                                        padding: "2px 6px",
                                        fontFamily: "Outfit",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                : '-'
                            }

                        </>
                    }
                </>
            ),
        },
        {
            name: "",
            field: "",
            renderer: (row) => (
                <Button onClick={() => onView(row)}>
                    View
                </Button>
            ),
        },
    ];

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden",
                    //minHeight: "636px"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    View Risk Details
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <CustomTabs tabs={tabs} handleTabChange={handleTabChange} tabValue={tabValue} />
                    </Grid>
                    {tabValue === 0 &&
                        <Grid size={{ md: 12, xs: 12 }} sx={{ minHeight: "80vh" }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                        Risk Information
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 2 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        {/* Risk-specific fields */}

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Project Name:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.projectName ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Risk Owner:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.riskOwner ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Category:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.category ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Status:</Typography>
                                            <StatusBadge status={rowData?.riskStatus} />
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Title:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.title ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Risk Rating:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.riskRating ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Severity:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.severity ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Impact Category:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.impactCategory ?? "N/A"}</Typography>
                                        </Grid>


                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Mitigation Plan:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.mitigationPlan ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Mitigation Action Status:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.mitigationActionStatus ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Target Closure Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                { rowData?.targetClosureDate ? moment(rowData?.targetClosureDate)?.format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Date Identified:</Typography>
                                            <Typography sx={valueStyle}>
                                                { rowData?.dateIdentified ? moment(rowData?.dateIdentified)?.format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        {/* <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Responsible Person:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.entityPersonResponsible ?? "N/A"}</Typography>
                                        </Grid> */}

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Remarks</Typography>
                                            <Typography sx={valueStyle}>{rowData?.remarks ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Created Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                { rowData?.createdDate ? moment(rowData?.createdDate)?.format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={12}>
                                            <Typography sx={labelStyle}>Description:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.description ?? ""}
                                            </Typography>
                                        </Grid>


                                    </Grid>
                                </CardContent>
                            </Card>

                        </Grid>
                    }
                  
                        <Grid size={{ md: 12, xs: 12 }} sx={{ minHeight: "80vh" }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                    mt: 1
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                        Mitigation Plan ( Action tracker item)
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 2 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 12 }}>
                                            {/* data is dummy pls remove */}
                                            {/* <CustomTable columns={columns} data={[{
                                      description: '1. Maintain close coordination and regular communication with the Authority to monitor land acquisition progress. 2. Obtain early and clear timelines from the Authority for land handover and incorporate contingencies in the project schedule. 3. Plan phased construction activities to optimize progress on available land parcels',
                                      status:'Open',
                                      assignedTo:'Ashok'
                                  }]} /> */}
                                            <CustomTable columns={columns(handleViewAction)} data={rowData?.projectActions || []} />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <ViewActionTracker
                                    open={isDialogOpen}
                                    handleClose={handleCloseDialog}
                                    rowData={selectedAction}  // or actionId={selectedAction?.id}
                                />

                            </Card>
                        </Grid>
                   
                    {/* {tabValue === 2 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={rowData?.projectRiskId} entityType="Risk" customId={rowData?.customId} isView={true} />
                        </Grid>
                    } */}
                </Grid>


            </DialogContent>
        </Dialog>
    );
};

export default ViewRisk;